import React from "react"
import { Box, Chip, createStyles, makeStyles, Theme, Typography } from "@material-ui/core"
import { useMoney } from "shared/Modules/Localization/useMoney"
import { LocalizedStrict } from "shared/Modules/Localization/Components/Localized"
import { toDinero } from "shared/Helpers/CurrencyHelper"
import { IMonetaryAmount } from "shared/Types/appTypes"

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        cardRow: {
            display: "flex",
            flexDirection: "row",
            gap: "2rem",
            alignItems: "center",
            justifyContent: "center",
            flexWrap: "wrap",
        },
        card: {
            cursor: "pointer",
            minWidth: "16rem",
            width: "100%",
            flex: "1 0 auto",
            height: "10rem",
            borderRadius: ".5rem",
            padding: "1rem",
            background: "radial-gradient(circle, rgba(2,0,36,0) 0%, rgba(0,193,245,1) 70%)",
        },
    })
)

type UserCardViewProps = Readonly<{
    balance: IMonetaryAmount
    statusLabel?: string
    displayName?: string
    brandingLabel?: string
    onSelect: () => void
}>

export function UserCardView({ onSelect, balance, statusLabel, displayName, brandingLabel }: UserCardViewProps) {
    const classes = useStyles()
    const moneyFactory = useMoney()

    return (
        <Box className={classes.cardRow} onClick={onSelect}>
            <Box className={classes.card}>
                <Box display="flex" flexDirection="column" justifyContent="space-between" height="100%">
                    <Box display="flex" flexDirection="row" justifyContent="space-between">
                        <Box>
                            <LocalizedStrict id="me-my-wallets-refill-select-card-balance">
                                <Typography variant="body2">Balance:</Typography>
                            </LocalizedStrict>
                            <Typography variant="h5">{moneyFactory.format(toDinero(balance))}</Typography>
                        </Box>
                        {statusLabel && <Chip label={statusLabel} />}
                    </Box>
                    <Box display="flex" flexDirection="column">
                        <Typography variant="subtitle1">{displayName}</Typography>
                        <Typography variant="subtitle2">{brandingLabel}</Typography>
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}
